const marketplace = [
	{
		path: '/ai/marketplace',
		name: 'ai-marketplace-list',
		component: () => import('@/views/ai/marketplace/list.vue'),
		meta: { layout: 'content', module: 'MGAI,marketplace' },
	},
	{
		path: '/ai/community-profiles',
		name: 'ai-community-profiles-list',
		redirect: { name: 'ai-profiles-list' },
		meta: { layout: 'content', module: 'MGAI,marketplace' },
	},
	{
		path: '/ai/usage',
		name: 'ai-usage-list',
		component: () => import('@/views/ai/usage/list.vue'),
		meta: { layout: 'content', module: 'MGAI,marketplace' },
	},
	{
		path: '/ai/insights',
		name: 'ai-insights-list',
		component: () => import('@/views/ai/insights/list.vue'),
		meta: { layout: 'content', module: 'MGAI,marketplace' },
	},
	{
		path: '/ai/quick-prompts',
		name: 'ai-quick-prompts-list',
		component: () => import('@/views/ai/quick-prompts/list.vue'),
		meta: { layout: 'content', module: 'MGAI,marketplace' },
	},
]

export default marketplace
